import Vue from 'vue';
import Router from 'vue-router';
import Front from '@/components/templates/Front';
import Intro from '@/components/templates/Intro';
import Markets from '@/components/templates/Markets';
import Installation from '@/components/templates/Installation';
import Workflow from '@/components/templates/Workflow';
import InteractivePdf from '@/components/templates/InteractivePdf';
import InteractiveHtml from '@/components/templates/InteractiveHtml';
import Movie from '@/components/templates/Movie';
import Specs from '@/components/templates/Specs';
import Backcover from '@/components/templates/Backcover';
import ThreeSixty from '@/components/templates/ThreeSixty';
import Orb from '@/components/templates/Orb';
import Slider from '@/components/templates/Slider';
import Table from '@/components/templates/Table';

Vue.use(Router);

export default new Router({
  routes: [
    { path: '*', redirect: '/0/front' },
    {
      path: '/:id/front',
      name: 'front',
      component: Front,
    },
    {
      path: '/:id/intro',
      name: 'intro',
      component: Intro,
    },
    {
      path: '/:id/markets',
      name: 'markets',
      component: Markets,
    },
    {
      path: '/:id/installation',
      name: 'installation',
      component: Installation,
    },
    {
      path: '/:id/workflow',
      name: 'workflow',
      component: Workflow,
    },
    {
      path: '/:id/interactive-pdf',
      name: 'interactive-pdf',
      component: InteractivePdf,
    },
    {
      path: '/:id/interactive-html',
      name: 'interactive-html',
      component: InteractiveHtml,
    },
    {
      path: '/:id/movie',
      name: 'movie',
      component: Movie,
    },
    {
      path: '/:id/specs',
      name: 'specs',
      component: Specs,
    },
    {
      path: '/:id/backcover',
      name: 'backcover',
      component: Backcover,
    },
    {
      path: '/:id/360/:tViewIndex/:canopy/:info/:selectedBullet',
      name: '360',
      component: ThreeSixty,
    },
    {
      path: '/:id/orb',
      name: 'orb',
      component: Orb,
    },
    {
      path: '/:id/slider',
      name: 'slider',
      component: Slider,
    },
    {
      path: '/:id/table',
      name: 'table',
      component: Table,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js